import { render, staticRenderFns } from "./OpenSelect.vue?vue&type=template&id=74df8baf"
import script from "./OpenSelect.vue?vue&type=script&lang=js"
export * from "./OpenSelect.vue?vue&type=script&lang=js"
import style0 from "./OpenSelect.vue?vue&type=style&index=0&id=74df8baf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports